import APP_BREAKPOINTS from '../components/styles/breakpoints'

export type DrawerDock = 'bottom' | 'right'

// A bottom-docked sheet stops short of the top so the app header stays visible
// above it: the header's height plus a 10px margin, pushed below the status bar
// where the viewport reports one
export const BOTTOM_DOCKED_TOP_GAP =
    'calc(env(safe-area-inset-top, 0px) + var(--header-height) + 10px)'

export const getDrawerDock = (
    windowWidth: number,
    portrait: boolean,
    fullWindow: boolean,
): DrawerDock =>
    !fullWindow && portrait && windowWidth < APP_BREAKPOINTS.tablet
        ? 'bottom'
        : 'right'

export const isNavOnBottom = (
    portrait: boolean,
    fullWindow: boolean,
): boolean => {
    return portrait && !fullWindow
}
